module.exports = __webpack_public_path__ + "img/logo.341e1cf7.png";